import HttpService from "./HttpService";
const API_URL = "/leave-type";

const LeaveTypeService = {
  fetchLeaveTypes: async () => {
    try {
      const response = await HttpService.get(`${API_URL}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching leave types:", error);
      throw error;
    }
  },
  fetchClientLeaveTypes: async () => {
    try {
      const response = await HttpService.get(`/client-portal/leave-types`);
      return response.data;
    } catch (error) {
      console.error("Error fetching leave types:", error);
      throw error;
    }
  },
  fetchLeaveTypesWithoutProbation: async () => {
    try {
      const response = await HttpService.get("/leave-type-without-probation");
      return response.data;
    } catch (error) {
      console.error("Error fetching leave types:", error);
      throw error;
    }
  },
  fetchLeaveTypesProbation: async () => {
    try {
      const response = await HttpService.get("/leave-type-probation");
      return response.data;
    } catch (error) {
      console.error("Error fetching leave types:", error);
      throw error;
    }
  },
  fetchLeaveTypesPaginated: async (pageConfig) => {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_URL}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching leave types:", error);
      throw error;
    }
  },

  addLeaveType: async (leaveTypeData) => {
    try {
      const response = await HttpService.post(API_URL, leaveTypeData);
      return response.data;
    } catch (error) {
      console.error("Error adding leave type:", error);
      throw error;
    }
  },

  editLeaveType: async (leaveTypeId) => {
    try {
      const response = await HttpService.get(`${API_URL}/${leaveTypeId}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  checkAvailableLeave: async (id, data) => {
    try {
      const response = await HttpService.post(`/check-leave/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateLeaveType: async (leaveTypeId, updatedLeaveType) => {
    // data["_method"] = "PUT";
    try {
      const response = await HttpService.put(
        `${API_URL}/${leaveTypeId}`,
        updatedLeaveType
      );
      return response.data;
    } catch (error) {
      console.error("Error updating leave type:", error);
      throw error;
    }
  },

  deleteLeaveType: async (leaveTypeId) => {
    try {
      const response = await HttpService.delete(`${API_URL}/${leaveTypeId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting leave type:", error);
      throw error;
    }
  },
};

export default LeaveTypeService;
